import React, { useState, useRef, useEffect } from "react";
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons';
import { GetTeams, Profile, UpdateProfile } from "../../API/auth";
import { avalibleSlotsAPI, RemoveAllPlayerWaitlist } from "../../API/player";
import Loader from '../admin/Common/Loader'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack';

import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CForm,
  CRow,
  CCol
} from '@coreui/react'
const ChangeTeamModal = () => {
  var sport = 'badminton'
  let onSubmitSuccess = () => {
    console.log("inside team chaning modal")
  }
  console.log("SPort", sport)

  const [visible, setVisible] = useState(false)
  const [teams, setTeams] = useState([]);
  const [SelectedTeam, setSelectedTeam] = useState(null);
  const [profile, setProfile] = useState(null);
  const [slotStatus, setSlotStatus] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false)
  let navigate = useNavigate()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()


  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      if (res.status) {
        console.log(res.data.profile_image);
        setProfile(res.data);

      }
    }


    callAPI();
  }, []);
  useEffect(() => {
    const getTeamsAPI = async () => {
      try {
        console.log("Team API", profile.city)
        let res = await GetTeams(profile.city);
        setTeams(res.data);
        setSelectedTeam(res.data[0].domain)
        console.log(res.data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };


    if (profile != null) {
      console.log("inside if  API", profile.corporate_email)

      getTeamsAPI();
    }

  }, [profile])

  useEffect(() => {
    let avalibleSlots = async () => {
      setloaderStatus(true)
      let formData = {
        team: SelectedTeam,
        gender: true
      }
      let res = await avalibleSlotsAPI(formData)
      console.log('responseee', res.data)
      if (res.status) {
        setloaderStatus(false)
        console.log(res.data.TotalResult.badminton)
        if (sport == 'badminton') {
          res.data.TotalResult.badminton > 0 ? setSlotStatus(true) : setSlotStatus(false)
        }

        if (sport == 'tennis') {
          res.data.TotalResult.table_tenis > 0 ? setSlotStatus(true) : setSlotStatus(false)
        }

        if (sport == 'bowling') {
          res.data.TotalResult.bowling > 0 ? setSlotStatus(true) : setSlotStatus(false)
        }

        if (sport == 'twok_run') {
          res.data.TotalResult.twok_run > 0 ? setSlotStatus(true) : setSlotStatus(false)
        }

      }
    }

    if (SelectedTeam != null) {

      avalibleSlots();
    }
  }, [SelectedTeam])
  let handleTeamChange = (e) => {
    setSelectedTeam(e.target.value)
  }

  let handleSubmit = async () => {
    if (profile.corporate_email === SelectedTeam) {
      enqueueSnackbar('You are already associated with selected team, please select another team', {
        variant: 'error', action: (key) => (
          <button className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key);
            }}
          >
            X
          </button>
        ),
      })
    } else {
      console.log("changing team")
      let formData = {
        id: profile.id,
        corporate_email: SelectedTeam
      }
      let res = await UpdateProfile(formData);
      if (res.data.status) {
        // delete all the entry in waiting list for this player
        let EmptyData = {
          data: null
        }
        let deleteAllWaitlist = await RemoveAllPlayerWaitlist(EmptyData)
        enqueueSnackbar("Team changed successfully", {
          variant: 'success', action: (key) => (
            <button className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
        // onClose(!visible)
        onSubmitSuccess()
      } else {
        enqueueSnackbar(res.data.message, {
          variant: 'error', action: (key) => (
            <button className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    }
  }
  return (

    <>
      {loaderStatus ? <Loader /> : null}

      <CButton color="primary" onClick={() => setVisible(!visible)}>Vertically centered modal</CButton>
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"
      >
        <CModalHeader>
          <CModalTitle id="VerticallyCenteredExample">Modal title</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>
            <CCol sm={8} md={8} lg={8}>
              <div className="mb-3">
                {
                  teams.length > 0 ? (
                    <>
                      <label className='mb-2 input-label' htmlFor="corporateEmail">Team</label>

                      <select
                        name='corporateEmail'
                        className='mb-4 form-control bg-transparent form-input'
                        onChange={(e) => handleTeamChange(e)}
                        value={SelectedTeam}
                        required
                      >
                        <option value="" disabled>
                          Select a Team
                        </option>
                        {

                          teams.map((entry, index) => (
                            <option key={index} value={entry.domain}>{entry.domain}</option>
                          ))
                        }
                      </select>
                    </>
                  ) : null
                }
              </div>

            </CCol>

            <CCol>
              <div>

                <label for="exampleInputEmail1" class="form-label">Slot status</label><br></br>
                {
                  slotStatus ? (
                    <button className='btn btn-success text-white '>Available</button>
                  ) : (
                    <button className='btn btn-secondary  disabled' style={{ 'backgroundColor': '#d3d3d3', border: 'none', color: 'rgb(12 8 8)' }}>Not Available </button>
                  )
                }
              </div>
            </CCol>
          </CRow>
          {
            profile != null ? (

              <p className="text-warning"> You are representing {profile.corporate_email} if you change the team. You will lose all the chances to play from {profile.corporate_email}.</p>
            ) : null
          }

        </CModalBody>
        <CModalFooter>
          <CButton color="btn btn-secondary" onClick={() => navigate('/dashboard')}>
            Continue  to dashboard
          </CButton>
          <CButton color="btn btn-danger text-white" onClick={() => handleSubmit()} disabled={slotStatus == false ? true : false}>Change Team</CButton>
        </CModalFooter>
      </CModal>

    </>
  )
}
export default ChangeTeamModal